var userCtrl = (function () {
  return {
    approval: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.users = false;
      $scope.currentPage = 1;
      $scope.pages = 0;
      $scope.searchKw = '';

      // User Counters
      var counters = function () {
        $scope.counters = {
          COMMUNITY: 0,
          GROUPS_ADM: 0,
          GROUPS_NOADM: 0,
          COURSES_ADM: 0,
          COURSES_NOADM: 0
        };
        var counter = function (key) {
          var requestUrl = 'user/counter';

          if (key == 'COMMUNITY') requestUrl = 'user/counter?signup_pending=true';
          else if (key == 'GROUPS_ADM') requestUrl = 'user/counter?signup_pending=true&scope=my_groups';
          else if (key == 'GROUPS_NOADM') requestUrl = 'user/counter?signup_pending=true&scope=others_groups';
          else if (key == 'COURSES_ADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=my_courses';
          else if (key == 'COURSES_NOADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=others_courses';

          Api.get(requestUrl, function (err, resp) {
            if (!err) $scope.counters[key] = resp.response;
          });
        };
        if ($scope.$parent.currentUser.role === 'ADM') for (var key in $scope.counters) counter(key);
        else {
          if ($scope.$parent.currentUser.is_group_adm) counter('GROUPS_ADM');
          if ($scope.$parent.currentUser.is_course_adm) counter('COURSES_ADM');
        }
      };
      counters();

      $scope.searchFilter = 'GROUPS_ADM';
      $scope.list = function (page, kw, filter) {
        $scope.users = false;
        $scope.last = true;
        $scope.currentPage = page;
        $scope.searchFilter = filter;
        $scope.searchKw = kw;
        if (kw !== '') {
          $translate('USER.STATUS_FILTER').then(function (result) {
            $scope.filter_label = result;
          });
        }

        $scope.searchFilter = filter;

        var requestUrl = 'user/list';
        var additionalQueryParams = '';

        if (filter == 'COMMUNITY') additionalQueryParams = 'signup_pending=true';
        else if (filter == 'GROUPS_ADM') additionalQueryParams = 'signup_pending=true&scope=my_groups';
        else if (filter == 'GROUPS_NOADM') additionalQueryParams = 'signup_pending=true&scope=others_groups';
        else if (filter == 'COURSES_ADM') {
          requestUrl = 'course/users';
          additionalQueryParams = 'signup_pending=true&scope=my_courses';
        } else if (filter == 'COURSES_NOADM') {
          requestUrl = 'course/users';
          additionalQueryParams = 'signup_pending=true&scope=others_courses';
        }

        Api.get(`${requestUrl}?return_as=list&page=${page}&page_size=10&sort_field=name&sort_order=ASC&filter=${kw}&${additionalQueryParams}`, function (err, resp) {
          if (!err) {
            $scope.users = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
          }
        });
      };
      $scope.filter_label = '';
      $scope.searchFilter_label = {
        COMMUNITY: '',
        GROUPS_ADM: '',
        GROUPS_NOADM: '',
        COURSES_ADM: '',
        COURSES_NOADM: ''
      };
      $translate('USER.SEARCH_FILTER_COMMUNITY').then(function (result) {
        $scope.searchFilter_label['COMMUNITY'] = result;
      });
      $translate('USER.SEARCH_FILTER_GROUPS_ADM').then(function (result) {
        $scope.searchFilter_label['GROUPS_ADM'] = result;
      });
      $translate('USER.SEARCH_FILTER_GROUPS_NOADM').then(function (result) {
        $scope.searchFilter_label['GROUPS_NOADM'] = result;
      });
      $translate('USER.SEARCH_FILTER_COURSES_ADM').then(function (result) {
        $scope.searchFilter_label['COURSES_ADM'] = result;
      });
      $translate('USER.SEARCH_FILTER_COURSES_NOADM').then(function (result) {
        $scope.searchFilter_label['COURSES_NOADM'] = result;
      });

      $scope.approve = function (user) {
        if (user.hasOwnProperty('course')) {
          Api.put(`courses/${user.course._id}/users/${user._id}/enrollment`, { signup_pending: false }, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_SUCCESS').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        } else if (user.hasOwnProperty('group')) {
          Api.put(`user/link_to_group/${user._id}`, { signup_pending: false, page_id: user.group._id }, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_SUCCESS').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        } else {
          Api.put(`user/link_to_project/${user._id}`, { signupPending: false }, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_SUCCESS').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        }
      };

      $scope.delete = function (user) {
        if (user.hasOwnProperty('course')) {
          Api.delete(`courses/${user.course._id}/users/${user._id}/enrollment`, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_FAIL').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        } else if (user.hasOwnProperty('group')) {
          Api.put(`user/link_to_group/${user._id}`, { action: 'delete', page_id: user.group._id }, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_FAIL').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        } else {
          Api.delete(`user/link_to_project/${user._id}`, function (err, ret) {
            if (!err) {
              $translate('USER.SIGNUP_FAIL').then(function (result) {
                App.toast(result, 3000);
              });
              $scope.list(1, $scope.searchKw, $scope.searchFilter);
              counters();
            }
          });
        }
      };

      $scope.list(1, $scope.searchKw, $scope.searchFilter);
    },

    user: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.users = false;
      $scope.currentPage = 1;
      $scope.pages = 0;
      $scope.searchKw = '';

      // User Counters
      var counters = function () {
        $scope.counters = {
          ALL: 0,
          POSTS: 0,
          GROUPS: 0,
          ADM: 0,
          EDITOR: 0
        };
        var counter = function (key) {
          var call = '';
          if (key == 'ADM') call = 'role=ADM';
          else if (key == 'EDITOR') call = 'role=EDITOR';
          else if (key == 'POSTS') call = 'has_posts=true';
          else if (key == 'GROUPS') call = 'has_groups=true';
          Api.get(`user/counter?${call}`, function (err, resp) {
            if (!err) $scope.counters[key] = resp.response;
          });
        };
        for (var key in $scope.counters) counter(key);
      };
      counters();

      $scope.searchFilter = 'ALL';
      $scope.searchLoading = false;
      $scope.list = function (page, kw, filter) {
        $scope.searchLoading = true;
        $scope.users = false;
        $scope.last = true;
        $scope.currentPage = page;
        $scope.searchFilter = filter;
        $scope.searchKw = kw;
        if (kw !== '') $scope.filter_label = 'filtrados';
        $scope.searchFilter = filter;
        var user_filter = '';
        if (filter == 'ADM') user_filter = 'role=ADM';
        else if (filter == 'EDITOR') user_filter = 'role=EDITOR';
        else if (filter == 'POSTS') user_filter = 'has_posts=true';
        else if (filter == 'GROUPS') user_filter = 'has_groups=true';
        Api.get(`user/list?signup_pending=false&page=${page}&page_size=30&sort_field=name&sort_order=ASC&filter=${kw}&${user_filter}`, function (err, resp) {
          if (!err) {
            $scope.users = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 30);
          }
          $scope.searchLoading = false;
        });
      };
      $scope.filter_label = '';
      $scope.searchFilter_label = {
        ALL: '',
        POSTS: '',
        GROUPS: '',
        ADM: '',
        EDITOR: ''
      };
      $translate('USER.SERACH_USER_FILTER_ALL').then(function (result) {
        $scope.searchFilter_label['ALL'] = result;
      });
      $translate('USER.SERACH_USER_FILTER_POSTS').then(function (result) {
        $scope.searchFilter_label['POSTS'] = result;
      });
      $translate('USER.SERACH_USER_FILTER_GROUPS').then(function (result) {
        $scope.searchFilter_label['GROUPS'] = result;
      });
      $translate('USER.SERACH_USER_FILTER_ADM').then(function (result) {
        $scope.searchFilter_label['ADM'] = result;
      });
      $translate('USER.SERACH_USER_FILTER_EDITOR').then(function (result) {
        $scope.searchFilter_label['EDITOR'] = result;
      });

      $scope.addUser = function (newUser, Form) {
        if (Form.$invalid) return false;
        if (!newUser.role) newUser.role = 'USR';
        Api.post('user/create', newUser, function (err, resp) {
          if (!err) {
            $translate('USER.ADD_USER_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
            $('#adduser').closeModal();
            counters();
            $scope.list(1, $scope.searchKw, $scope.searchFilter);
          }
        });
      };

      $scope.list(1, $scope.searchKw, $scope.searchFilter);
    },

    blocked: function ($scope, Api) {
      $scope.users = false;
      $scope.total = false;
      $scope.currentPage = 1;
      $scope.pages = 0;
      $scope.searchKw = '';

      $scope.userTotal = 0;
      Api.get(`user/counter?banned=true`, function (err, resp) {
        if (!err) $scope.userTotal = resp.response;
      });

      $scope.list = function (page, kw) {
        $scope.users = false;
        $scope.last = true;
        $scope.currentPage = page;
        $scope.searchKw = kw;
        if (kw !== '') $scope.filter_label = 'filtrados';
        Api.get(`user/list?signup_pending=false&page=${page}&page_size=10&sort_field=name&sort_order=ASC&filter=${kw}&banned=true`, function (err, resp) {
          if (!err) {
            $scope.users = resp.response.data;
            $scope.total = resp.response.total;
            $scope.pages = Math.ceil(resp.response.total / 10);
          }
        });
      };
      $scope.filter_label = '';

      $scope.list(1, $scope.searchKw);
    },

    userDetail: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      // Post count
      $scope.post_count = 0;
      $scope.course = [];
      $scope.courseFilter = '';
      $scope.courseGroupFilter = '';
      $scope.courseGroups = [];
      $scope.currentTab = 'tab-1';
      $scope.dateFormat = 'MM/dd/yyyy';
      if (bcp.settings.language === 'pt-br') {
        $scope.dateFormat = 'dd/MM/yyyy';
      }
      $scope.statistics = {
        progress: 0,
        total_access: 0,
        total_classes: 0,
        total_completed_classes: 0
      };
      // TAB BADGES
      $scope.badgesAssigned = [];
      $scope.badgesAssignedTotal = 0;
      $scope.badgesNotAssigned = [];
      $scope.badgesNotAssignedTotal = 0;
      $scope.loadingBadges = false;

      // ENDTAB BADGES

      // TAB NPS
      $scope.courses = [];
      $scope.courseId = null;
      $scope.classNPS = '';
      $scope.loadingNPS = false;
      $scope.currentPageNPS = 1;
      $scope.totalClassesNPS = 0;
      $scope.reviewType = null;
      $scope.questionType = null;

      $scope.changeQuestion = function (filterQuestionSelected) {
        $scope.filterQuestionSelected = filterQuestionSelected.id;
        $scope.questionType = filterQuestionSelected.question_type;
      };

      $scope.changeCourse = function (courseId) {
        $scope.courseId = courseId;
      };

      $scope.getQuestionsNPS = function () {
        Api.get('custom-survey-questions/lightweight/all', function (err, ret) {
          if (!err) {
            $scope.questions = ret.response.data;
          }
        });
      };

      $scope.getQuestionsNPS();

      Api.get(`course?scope=all&return_as=list&sort_order=DESC&sort_field=title&page_size=1000&page=1`, function (err, resp) {
        if (!err) {
          $scope.courses = resp.response.data;
          $scope.courseId = $scope.courses[0].id;
        }
      });

      $scope.getUserNPS = function (page, pageSize) { 
        $scope.loadingNPS = true;
        Api.get(`user_experience_review/questions/${$scope.filterQuestionSelected}/users/${$scope.id}/classes?course_id=${$scope.courseId}&page=${page}&page_size=${pageSize}`, function (err, resp) {
          if (!err) {
            $scope.classNPS = resp.response.data.reviews;
            $scope.totalClassesNPS = resp.response.data.total;
          }
          $scope.loadingNPS = false;          
        });
      };
      // End Tab NPS

      Api.get(`article/counter?status=PUBLISHED&mode=ALL&user_id=${$scope.id}`, function (err, resp) {
        if (!err) $scope.post_count = resp.response;
      });

      $scope.changeTab = function (tab) {
        $('ul.tabs').tabs('select_tab', tab);
      };

      // Change user role
      $scope.role = function (role) {
        var payload = { role: role };
        Api.put(`user/role/${$scope.id}`, payload, function (err, resp) {
          if (!err) {
            $translate('MESSAGES.ROLE_UPDATED').then(function (result) {
              App.toast(result, 3000);
            });
            $scope.user.role = role;
          }
        });
      };

      // Block / Unblock user
      $scope.block = function (banned) {
        if (banned == 0) {
          Api.post(`user/block`, { id: $scope.id }, function (err, resp) {
            $translate('MESSAGES.USER_BLOCKED').then(function (result) {
              App.toast(result, 3000);
            });
            App.toast(TXT.USER_BLOCKED, 3000);
          });
        } else {
          Api.delete(`user/block/${$scope.id}`, function (err, resp) {
            $translate('MESSAGES.USER_UNBLOCKED').then(function (result) {
              App.toast(result, 3000);
            });
          });
        }
        $scope.user.banned = banned === 1 ? 0 : 1;
      };

      $scope.loadCourseGroups = function (id) {
        if (id) {
          $scope.statistics = {
            progress: 0,
            total_access: 0,
            total_classes: 0,
            total_completed_classes: 0
          };
          Api.get(`user/${$scope.id}/courses/${id}/course-groups`, function (err, ret) {
            if (err) {
              $scope.courseGroups = [];
              return false;
            }
            $scope.courseGroups = ret.response.data;
          });
        }
      };

      $scope.getSummary = function (courseGroupId) {
        if (courseGroupId) {
          Api.get(`users/${$scope.id}/course-groups/${courseGroupId}/statistics/summary`, function (err, resp) {
            if (!err) {
              $scope.statistics = resp.response.data;
            }
          });
        }
      };

      // TAB BADGES
      $scope.getBadges = function () {
        $scope.loadingBadges = true;
        Api.get(`badges/users/${$scope.id}/associated?skip=0&take=100`, function (err, resp) {
          if (!err) {
            $scope.badgesAssociated = resp.response.data.badges;
            $scope.badgesAssignedTotal = resp.response.data.total;
          }
          $scope.loadingBadges = false;
        });

        $scope.loadingBadges = true;
        Api.get(`badges/users/${$scope.id}/not-associated?skip=0&take=100`, function (err, resp) {
          if (!err) {
            $scope.badgesNotAssociated = resp.response.data.badges;
            $scope.badgesNotAssignedTotal = resp.response.data.total;
          }
          $scope.loadingBadges = false;
        });
      };
      $scope.getBadges();

      $scope.assignBadge = function (badge) {
        badge.disabled = true;
        Api.post(`badges/${badge.id}/users/${$scope.id}`, {}, function (err, resp) {
          if (!err) {
            const index = $scope.badgesNotAssociated.indexOf(badge);
            if (index > -1) {
              $scope.badgesNotAssociated.splice(index, 1);
            }
            $scope.badgesAssociated.push(badge);
            $translate('USER.USER_ASSIGNED_BADGE').then(function (result) {
              App.toast(result, 3000);
            });
          }
          badge.disabled = false;
        });
      };

      $scope.removeBadge = function (badge) {
        badge.disabled = true;
        Api.delete(`badges/${badge.id}/users/${$scope.id}`, function (err, resp) {
          if (!err) {
            const index = $scope.badgesAssociated.indexOf(badge);
            if (index > -1) {
              $scope.badgesAssociated.splice(index, 1);
            }
            $scope.badgesNotAssociated.push(badge);
            $translate('USER.USER_REMOVED_BADGE').then(function (result) {
              App.toast(result, 3000);
            });
          }
          badge.disabled = false;
        });
      };
      // ENDTAB BADGES
    },

    userExport: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.exports = [];
      $scope.exporting = false;
      $scope.groups = [];
      $scope.exportTypes = [];
      $scope.exportType = '';
      $translate(['CONTENT.MAIN_BLOG_TITLE', 'USER.USERS_EXPORT_TYPE_GROUPS', 'USER.USERS_EXPORT_TYPE_COURSES']).then(function (translations) {
        $scope.exportTypes.push({
          title: translations['CONTENT.MAIN_BLOG_TITLE'],
          value: 'community'
        });

        if ($scope.project_data.plan.groups_feature_enabled) {
          $scope.exportTypes.push({
            title: translations['USER.USERS_EXPORT_TYPE_GROUPS'],
            value: 'groups'
          });
        }

        if ($scope.project_data.plan.courses_feature_enabled) {
          $scope.exportTypes.push({
            title: translations['USER.USERS_EXPORT_TYPE_COURSES'],
            value: 'courses'
          });
        }

        $scope.exportType = $scope.exportTypes[0];
      });

      var list = function (id) {
        Api.get(`users/exports`, function (err, data) {
          if (!err) {
            var exports = data.response.data;
            for (var i = 0; i < exports.length; i++) {
              var date = new Date(exports[i].request_date);
              exports[i].request_date = date.toISOString();
              if (!exports[i].is_exported) $scope.exporting = true;
            }
            $scope.exports = exports;
          }
        });
      };
      if ($scope.project_data.plan.user_list_exportation_feature_enabled) list();

      $scope.download = function (id) {
        Api.get(`users/exports/${id}`, function (err, resp) {
          if (!err) window.location.href = resp.response.data;
        });
      };

      $scope.export = function (value) {
        const data = value ? { export_type: value } : {};
        Api.post('users/exports', data, function (err, data) {
          list();
        });
      };

      $scope.changeExportType = function (selectedType) {
        $scope.exportType = selectedType;
      };
    }
  };
})();
